import { useState } from "react";
import { navCategories, siteMeta } from "@/mocks/home";

export default function SiteHeader() {
  const [activeCat, setActiveCat] = useState("all");
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [hint, setHint] = useState("");

  const handleSearch = () => {
    const value = keyword.trim();
    if (!value) {
      setHint("输入关键词后即可在全部档案中检索");
      return;
    }
    setHint(`已在档案库中标记「${value}」相关条目，共 37 条待查看`);
  };

  return (
    <header className="sticky top-0 z-50 w-full">
      <div className="w-full bg-primary-800">
        <div className="mx-auto flex h-9 max-w-[1400px] items-center gap-3 px-4 md:px-6">
          <span className="flex h-4 w-4 shrink-0 items-center justify-center text-primary-100">
            <i className="ri-megaphone-line text-sm" />
          </span>
          <div className="relative flex-1 overflow-hidden">
            <p className="truncate text-[12px] text-primary-100">{siteMeta.notice}</p>
          </div>
          <div className="hidden shrink-0 items-center gap-4 text-[12px] text-primary-100 md:flex">
            <span>2026 年 09 月 11 日</span>
            <span className="h-3 w-px bg-primary-500/70" />
            <a href="#index" className="transition-colors hover:text-background-50">
              更新日志
            </a>
            <a href="#footer" className="transition-colors hover:text-background-50">
              纠错通道
            </a>
          </div>
        </div>
      </div>

      <div className="w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
        <div className="mx-auto flex h-16 max-w-[1400px] items-center gap-4 px-4 md:px-6">
          <a href="#top" className="flex shrink-0 items-center gap-2.5">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-archive-2-line text-xl" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
                {siteMeta.name}
              </span>
              <span className="mt-0.5 text-[11px] tracking-[0.2em] text-foreground-500">
                完整档案 · 深度整理
              </span>
            </span>
          </a>

          <nav className="hidden flex-1 items-center justify-center gap-1 lg:flex">
            {navCategories.map((item) => (
              <button
                key={item.key}
                type="button"
                onClick={() => setActiveCat(item.key)}
                className={`whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors ${
                  activeCat === item.key
                    ? "bg-primary-100 font-medium text-primary-800"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`}
              >
                {item.label}
              </button>
            ))}
          </nav>

          <div className="ml-auto flex items-center gap-2">
            <div className="hidden items-center rounded-md border border-background-300 bg-background-100 md:flex">
              <span className="flex h-9 w-9 items-center justify-center text-foreground-500">
                <i className="ri-search-2-line text-base" />
              </span>
              <input
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                onKeyDown={(event) => {
                  if (event.key === "Enter") handleSearch();
                }}
                placeholder="检索档案编号或话题"
                className="h-9 w-44 bg-transparent pr-2 text-sm text-foreground-800 outline-none placeholder:text-foreground-400 xl:w-56"
              />
            </div>
            <button
              type="button"
              onClick={handleSearch}
              className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:block"
            >
              检索
            </button>
            <button
              type="button"
              onClick={() => setMenuOpen((open) => !open)}
              aria-label="展开导航"
              className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 lg:hidden"
            >
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
            </button>
          </div>
        </div>

        {menuOpen && (
          <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 lg:hidden">
            <div className="mb-3 flex items-center rounded-md border border-background-300 bg-background-100">
              <span className="flex h-10 w-10 items-center justify-center text-foreground-500">
                <i className="ri-search-2-line text-base" />
              </span>
              <input
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="检索档案编号或话题"
                className="h-10 flex-1 bg-transparent pr-2 text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
              />
              <button
                type="button"
                onClick={handleSearch}
                className="mr-1 whitespace-nowrap rounded-md bg-primary-500 px-3 py-1.5 text-sm text-background-50"
              >
                检索
              </button>
            </div>
            <div className="flex flex-wrap gap-2">
              {navCategories.map((item) => (
                <button
                  key={item.key}
                  type="button"
                  onClick={() => {
                    setActiveCat(item.key);
                    setMenuOpen(false);
                  }}
                  className={`whitespace-nowrap rounded-md px-3 py-1.5 text-sm ${
                    activeCat === item.key
                      ? "bg-primary-100 font-medium text-primary-800"
                      : "bg-background-100 text-foreground-700"
                  }`}
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>
        )}

        {hint && (
          <div className="border-t border-primary-200 bg-primary-50 px-4 py-2 md:px-6">
            <p className="mx-auto flex max-w-[1400px] items-center gap-2 text-xs text-primary-800">
              <i className="ri-information-line text-sm" />
              {hint}
            </p>
          </div>
        )}
      </div>
    </header>
  );
}